export const rem = px => {
  return px / 16 + "rem"
}
